import { Routes, RouterModule } from '@angular/router';
import { AccountLayoutComponent } from './layout/account-layout.component';
import { AccountDashboardComponent } from './dashboard/account-dashboard.component';
import { AccountSettingsModule } from './settings/account-settings.module';
import { AccountCandidatesModule } from './candidates/account-candidates.module';
import { AccountLiveFeedComponent } from './live-feed/account-live-feed.component';
import { AccountFunnelsModule } from './funnels/account-funnels.module';
import { AccountFunnelModule } from './funnel/account-funnel.module';
import { AccountTodosModule } from './todos/account-todos.module';

const accountRoutes: Routes = [
  // Account routes
  {
    path: 'account/:account_id',
    component: AccountLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      { path: 'dashboard', component: AccountDashboardComponent },
      {
        path: 'candidates',
        loadChildren: () => AccountCandidatesModule,
        // component: AccountFunnelLayoutComponent,
      },
      {
        path: 'funnels',
        loadChildren: () => AccountFunnelsModule,
      },
      {
        path: 'todos',
        loadChildren: () => AccountTodosModule,
      },
      {
        path: 'funnels/:funnel_id',
        loadChildren: () => AccountFunnelModule,
      },
      { path: 'events', component: AccountLiveFeedComponent },
      {
        path: 'settings',
        loadChildren: () => AccountSettingsModule,
        // './account/settings/account-settings.module#AccountSettingsModule',
      },
    ],
  },
];

export const AccountRouting = RouterModule.forChild(accountRoutes);
